import { Component, ChangeDetectionStrategy, Input, ChangeDetectorRef, ContentChildren } from '@angular/core';
import { AmdNavbarItemComponent } from './navbar-item/navbar-item.component';
var AmdNavbarComponent = /** @class */ (function () {
    /**
     * @param {?} changeDetectorRef
     */
    function AmdNavbarComponent(changeDetectorRef) {
        this.changeDetectorRef = changeDetectorRef;
        this.navbarThemeClass = 'amd-navbar--default';
        this._theme = 'default';
    }
    Object.defineProperty(AmdNavbarComponent.prototype, "theme", {
        /**
         * @param {?} theme
         * @return {?}
         */
        set: function (theme) {
            this.navbarThemeClass = "amd-navbar--" + theme;
            this._theme = theme;
            this.setThemeOnChildren();
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(AmdNavbarComponent.prototype, "navbarItems", {
        /**
         * @param {?} navbarItems
         * @return {?}
         */
        set: function (navbarItems) {
            this._navbarItems = navbarItems;
            this.setThemeOnChildren();
        },
        enumerable: true,
        configurable: true
    });
    /**
     * @return {?}
     */
    AmdNavbarComponent.prototype.ngAfterContentInit = function () {
        this.setThemeOnChildren();
    };
    /**
     * @return {?}
     */
    AmdNavbarComponent.prototype.setThemeOnChildren = function () {
        var _this = this;
        if (this._navbarItems) {
            this._navbarItems.forEach(function (item) {
                item.theme = _this._theme;
            });
        }
        this.changeDetectorRef.markForCheck();
    };
    AmdNavbarComponent.decorators = [
        { type: Component, args: [{
                    selector: 'amd-navbar',
                    template: "<div class=\"amd-navbar\" [ngClass]=\"navbarThemeClass\"> <ng-content></ng-content> </div>",
                    changeDetection: ChangeDetectionStrategy.OnPush
                },] },
    ];
    /**
     * @nocollapse
     */
    AmdNavbarComponent.ctorParameters = function () { return [
        { type: ChangeDetectorRef, },
    ]; };
    AmdNavbarComponent.propDecorators = {
        'theme': [{ type: Input },],
        'navbarItems': [{ type: ContentChildren, args: [AmdNavbarItemComponent, { descendants: true },] },],
    };
    return AmdNavbarComponent;
}());
export { AmdNavbarComponent };
function AmdNavbarComponent_tsickle_Closure_declarations() {
    /** @type {?} */
    AmdNavbarComponent.decorators;
    /**
     * @nocollapse
     * @type {?}
     */
    AmdNavbarComponent.ctorParameters;
    /** @type {?} */
    AmdNavbarComponent.propDecorators;
    /** @type {?} */
    AmdNavbarComponent.prototype.navbarThemeClass;
    /** @type {?} */
    AmdNavbarComponent.prototype._navbarItems;
    /** @type {?} */
    AmdNavbarComponent.prototype._theme;
    /** @type {?} */
    AmdNavbarComponent.prototype.changeDetectorRef;
}
//# sourceMappingURL=navbar.component.js.map
//# sourceMappingURL=navbar.component.js.map
